import axios from 'axios';
const instance = axios.create({
  baseURL: `${process.env.REACT_APP_FEATURED_API}`,
  headers: {
    Authorization: `JWT ${localStorage.getItem('token')}`,
  },
});
export default instance